module.exports = __webpack_public_path__ + "static/15-3014014e4a14f9751841627d08fd74a9.jpeg";